/* Live preview and printing for the gift voucher generator.
 *
 * Reads the query string first so an order confirmation can deep-link a
 * pre-filled voucher, then keeps the preview in step as fields are edited.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-voucher-form]');
  var voucher = document.getElementById('mx-voucher');
  if (!form || !voucher) return;

  var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-bind]'));

  function out(name) {
    return voucher.querySelector('[data-out="' + name + '"]');
  }

  /* Placeholders keep the printed voucher looking like a voucher rather than a
     form with gaps, and show the layout before anything is typed. */
  var PLACEHOLDER = {
    to: '________________________',
    from: '________________________',
  };

  function paint() {
    var data = {};
    inputs.forEach(function (el) {
      data[el.getAttribute('data-bind')] = el.value.trim();
    });

    ['to', 'from'].forEach(function (k) {
      var node = out(k);
      if (node) node.textContent = data[k] || PLACEHOLDER[k];
    });

    var n = parseInt(data.lessons, 10) || 1;
    var entitles = out('entitles');
    if (entitles) {
      entitles.textContent =
        'This voucher entitles the holder to ' +
        n +
        (n === 1 ? ' lesson' : ' lessons') +
        ' with PGA Professional Andy Stocks';
    }

    var msg = out('message');
    if (msg) {
      msg.textContent = data.message || '';
      msg.hidden = !data.message;
    }

    var code = out('code');
    if (code) {
      code.textContent = data.code ? 'Ref ' + data.code : '';
      code.hidden = !data.code;
    }

    var exp = out('expiry');
    if (exp) {
      exp.textContent = data.expiry ? 'Valid until ' + data.expiry : '';
      exp.hidden = !data.expiry;
    }
  }

  /* Prefill from ?to=&from=&lessons=&code=&message=&expiry= */
  try {
    var q = new URLSearchParams(window.location.search);
    inputs.forEach(function (el) {
      var v = q.get(el.getAttribute('data-bind'));
      if (v !== null) el.value = v;
    });
  } catch (e) {
    /* An ancient browser without URLSearchParams still gets a typeable form. */
  }

  inputs.forEach(function (el) {
    el.addEventListener('input', paint);
    el.addEventListener('change', paint);
  });

  var printBtn = form.querySelector('[data-print]');
  if (printBtn) {
    printBtn.addEventListener('click', function () {
      window.print();
    });
  }

  paint();
})();
